import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req.clone({
      setHeaders: {
        Authorization: environment.REST_API.AUTH_TYPE + ' ' + btoa(environment.REST_API.AUTH_USERNAME + ':' + environment.REST_API.AUTH_PASSWORD)
      },
      url: req.url.replace('@PROTOCOLO', environment.ENVIRONMENT.PROTOCOLO)
    });
    return next.handle(request);
  }
}
